export default __webpack_public_path__ + "static/media/Price_And_Shipping_Update_Summary_18092025.481dae5d.zip";